import { AfterViewInit, Component, ElementRef, inject, OnDestroy, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { TegelModule } from '@scania/tegel-angular-17';
import { ModalAction } from '../../models/modal-action';
import { ModalConfig } from '../../models/modal-config';
import { ModalService } from '../../services/modal.service';
import { NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'app-modal',
  imports: [TegelModule, NgTemplateOutlet],
  templateUrl: './modal.html',
})
export class Modal implements AfterViewInit, OnDestroy {
  private readonly modalService = inject(ModalService);
  @ViewChild('modalEl', { read: ElementRef }) modalEl!: ElementRef<HTMLElement>;

  config: ModalConfig = {};
  actions: ModalAction[] = [];
  private sub?: Subscription;
  private resolver?: (v: any) => void;

  private readonly sizes = {
    small: 'sm',
    medium: 'md',
    large: 'lg',
  } as const;

  ngAfterViewInit(): void {
    this.sub = this.modalService.requests$.subscribe(async (req) => {
      this.config = req.config;
      this.actions = [...(req.config.actions ?? [])];
      this.resolver = req.resolve;

      const el = this.modalEl?.nativeElement as any;

      if (!el) {
        console.error('[ModalHost] modalEl is undefined (ViewChild not resolved)');
        req.resolve({ ok: false, error: 'modalEl undefined' });
        return;
      }

      el.header = this.config.header ?? '';
      el.size = this.sizes[this.config.size ?? 'medium'];
      el.prevent = !!this.config.preventBackdropClose;
      el.closable = this.config.closable ?? true;

      if (typeof el.showModal === 'function') {
        await el.showModal();
      } else {
        console.error('[ModalHost] showModal() not available (Tegel not registered?)');
      }
    });
  }

  async onActionClick(action: ModalAction): Promise<void> {
    const result = await action.onClick?.();

    if (action.dismiss && result !== false) {
      await this.close(action);
    }
  }

  async close(result?: unknown): Promise<void> {
    const el = this.modalEl.nativeElement as any;

    await el.closeModal();

    this.resolver?.(result);
    this.resolver = undefined;
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }
}
